var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'underscore', 'core', 'app-common/component/api-call', 'app-common/component/service-call'], function($, _, core, apiCall, serviceCall) {
  var findData, findEventsCounters, getEventNameByNavigationMode, getInboxEvents, getNavigationModeByEventName, inboxEvents, navigationModes, refresh, refreshEventCounters, updateAndRefreshEventCounters;
  inboxEvents = [];
  navigationModes = {
    'ND': 'feed.receipt.created',
    'RT': 'feed.transaction.recategorized',
    'RR': 'feed.receipt.recategorized',
    'NS': 'feed.statement.created',
    'US': 'unprocessed.statement'
  };
  getInboxEvents = function() {
    return inboxEvents;
  };
  findData = function(currentId, eventName) {
    var currentIdIndex, events;
    currentId = currentId.toString();
    events = _.find(getInboxEvents(), function(eventItem) {
      var _ref;
      if (_.isArray(eventName)) {
        return (_ref = eventItem.eventName, __indexOf.call(eventName, _ref) >= 0) && __indexOf.call(eventItem.resourceIds, currentId) >= 0;
      } else {
        return eventItem.eventName === eventName && __indexOf.call(eventItem.resourceIds, currentId) >= 0;
      }
    });
    currentIdIndex = events ? _.indexOf(events.resourceIds, currentId) : -1;
    return [events, currentIdIndex];
  };
  findEventsCounters = function(pageId, typeObj) {
    var counters, getCounter, type, _i, _len;
    getCounter = function(type) {
      var eventData, navigationMode, urlParams;
      eventData = _.findWhere(getInboxEvents(), {
        eventName: type.name
      });
      if (eventData) {
        urlParams = type.noURLid ? [] : [eventData.resourceIds[0]];
        navigationMode = getNavigationModeByEventName(type.name);
        if (navigationMode === 'NS') {
          pageId = "document-entry";
          urlParams.push(eventData.resourceIds[0], 'NS');
        } else {
          urlParams.push(navigationMode);
        }
        return {
          type: type.name,
          secondary: type.secondary,
          offset: type.offset,
          title: type.title,
          count: eventData.counter,
          url: core.getRouter().buildUrl(pageId, urlParams)
        };
      }
    };
    counters = [];
    if (_.isArray(typeObj)) {
      for (_i = 0, _len = typeObj.length; _i < _len; _i++) {
        type = typeObj[_i];
        counters.push(getCounter(type));
      }
    } else if (typeObj) {
      counters.push(getCounter(typeObj));
    }
    return _.compact(counters);
  };
  refreshEventCounters = function() {
    var counter, counterElem, counters, i, item, itemCounterElem, itemElem, j, menu, section, _i, _len, _results;
    menu = $.extend(true, [], core.getConfig().widgets);
    _results = [];
    for (i = _i = 0, _len = menu.length; _i < _len; i = ++_i) {
      section = menu[i];
      _results.push((function() {
        var _j, _k, _len1, _len2, _ref, _results1;
        _ref = section.items;
        _results1 = [];
        for (j = _j = 0, _len1 = _ref.length; _j < _len1; j = ++_j) {
          item = _ref[j];
          itemElem = $("#" + item.id + "-menu-item");
          itemCounterElem = itemElem.find('.menu-item-counter-wrapper');
          counters = findEventsCounters(item.id, item.eventsCounterType);
          if (counters) {
            counterElem = '';
            for (_k = 0, _len2 = counters.length; _k < _len2; _k++) {
              counter = counters[_k];
              counterElem += "<a class='router-url counter-url menu-item-counter" + (counter.offset ? ' ' + counter.offset : '') + "' data-type='" + counter.type + "' data-title='" + item.title + "' title='" + counter.title + "' href='" + counter.url + "'>\n    " + counter.count + "\n</a>";
            }
            itemCounterElem.html(counterElem);
            if (counters.length > 1) {
              _results1.push(itemCounterElem.addClass('multiple'));
            } else {
              _results1.push(itemCounterElem.removeClass('multiple'));
            }
          } else {
            _results1.push(itemCounterElem.html(''));
          }
        }
        return _results1;
      })());
    }
    return _results;
  };
  refresh = function() {
    var filters, getEvents, getStatements, params;
    filters = {
      cids: core.getCurrentClientId(),
      group: 'BENCH'
    };
    params = $.param(filters);
    getEvents = function() {
      return serviceCall('nodeway', "actionables/bk/" + (core.getCurrentUserid()) + "?preview=true&" + params);
    };
    getStatements = function() {
      return apiCall('reconciliation', "unprocessed/" + (core.getCurrentClientId()), 'GET');
    };
    return $.when(getEvents(), getStatements()).done(function(eventsResponse, statementsResponse) {
      var statementEvents, statementIds;
      inboxEvents = eventsResponse[0][0].events.previews;
      statementIds = statementsResponse[0];
      if (statementIds.length) {
        statementEvents = {
          eventName: 'unprocessed.statement',
          resourceIds: _.map(statementIds, function(id) {
            return id.toString();
          }),
          counter: statementIds.length
        };
        return inboxEvents = inboxEvents.concat(statementEvents);
      }
    });
  };
  updateAndRefreshEventCounters = function() {
    var refreshPromise;
    refreshPromise = refresh();
    refreshPromise.done(function() {
      return refreshEventCounters();
    });
    return refreshPromise;
  };
  getNavigationModeByEventName = function(eventName) {
    return _.invert(navigationModes)[eventName];
  };
  getEventNameByNavigationMode = function(mode) {
    return navigationModes[mode];
  };
  return {
    init: function() {
      if (typeof core.isCurrentClientBookkeeper === "function" ? core.isCurrentClientBookkeeper() : void 0) {
        return refresh();
      } else {
        return new $.Deferred().resolve();
      }
    },
    /*
    # @param String currentId
    # @param String|Array eventName
    */

    getPrevId: function(currentId, eventName) {
      var currentIdIndex, events, _ref;
      _ref = findData(currentId, eventName), events = _ref[0], currentIdIndex = _ref[1];
      return events != null ? events.resourceIds[currentIdIndex - 1] : void 0;
    },
    /*
    # @param String currentId
    # @param String|Array eventName
    */

    getNextId: function(currentId, eventName) {
      var currentIdIndex, events, _ref;
      _ref = findData(currentId, eventName), events = _ref[0], currentIdIndex = _ref[1];
      return events != null ? events.resourceIds[currentIdIndex + 1] : void 0;
    },
    /*
    @return {nextId: String, prevId: String, currentPosition: Int, total: Int}
    */

    getNavigation: function(currentId, eventName) {
      var currentIdIndex, events, _ref;
      _ref = findData(currentId, eventName), events = _ref[0], currentIdIndex = _ref[1];
      if (events && currentIdIndex > -1) {
        return {
          nextId: events.resourceIds[currentIdIndex + 1],
          prevId: events.resourceIds[currentIdIndex - 1],
          currentPosition: currentIdIndex + 1,
          total: events.resourceIds.length,
          eventName: events.eventName
        };
      } else {
        return {};
      }
    },
    getNavigationModeByEventName: getNavigationModeByEventName,
    getEventNameByNavigationMode: getEventNameByNavigationMode,
    getresourceIdsByType: function(eventName) {
      var _ref;
      return (_ref = _.findWhere(getInboxEvents(), {
        eventName: eventName
      })) != null ? _ref.resourceIds : void 0;
    },
    markAsDone: function(resourceId, eventName, callback) {
      var params, promise;
      if (!resourceId || !eventName) {
        if (typeof callback === "function") {
          callback();
        }
        return;
      }
      params = $.param({
        group: 'BENCH'
      });
      promise = serviceCall('nodeway', "actionables/" + (core.getCurrentUserid()) + "/resources/" + resourceId + "/" + eventName + "?" + params, 'DELETE');
      promise.always(function() {
        return typeof callback === "function" ? callback() : void 0;
      });
      promise.done(function() {
        return setTimeout(function() {
          return updateAndRefreshEventCounters();
        }, 1000);
      });
      return promise;
    },
    refreshEventCounters: refreshEventCounters,
    updateAndRefreshEventCounters: updateAndRefreshEventCounters,
    findEventsCounters: findEventsCounters
  };
});
